<template>
	<div class="Search">
		<TopMenu :isShow="true"></TopMenu>
		<div class="videoInfoBox">
			<div class="videoBox" v-if="videoInfo && videoInfo.poster && videoInfo.videoUrl">
				<div class="videoPlayer">
					<video-player class="video-player vjs-custom-skin" ref="videoPlayer" playsinline
						:options="playerOptions">
					</video-player>
					<!-- <vue-plyr ref="player" :options="options">
						<video controls crossorigin playsinline :poster="videoInfo.poster" style="object-fit:cover">
							<source :src="videoInfo.videoUrl" type="video/mp4" />
						</video>
					</vue-plyr> -->
				</div>
				<div class="otherShareBox">
					<div class="titleTime">
						<div class="playNum">
							{{detailsData.Clicks}}次播放 ·
						</div>
						<div class="timeBox">
							发布于{{detailsData.UpdateDate}}
							<span>
								时长{{detailsData.Duration}}
							</span>
						</div>
					</div>
					<div class="shareBox">
						分享至
						<div class="shareType">
							<img class="shareImg" src="../assets/wx.png" alt="" @click="shareWx">
							<img class="shareImg" src="../assets/qq.png" alt="" @click="shareQq">
							<img class="shareImg" src="../assets/wb.png" alt="" @click="shareWb">
						</div>
					</div>
				</div>


				<!-- <div class="desShare">
					<div class="desBox" @mouseenter="hotMouseLookAllEnter" @mouseleave="hotMouseLookAllLeave">
						{{detailsData.Intro}}
						<div class="lookAll" @mouseenter="hotMouseLookAllEnter" @mouseleave="hotMouseLookAllLeave">
							查看全部
						</div>
					</div>
					<div class="shareBox">
						分享至
						<div class="shareType">
							<img class="shareImg" src="../assets/wx.png" alt="" @click="shareWx">
							<img class="shareImg" src="../assets/qq.png" alt="" @click="shareQq">
							<img class="shareImg" src="../assets/wb.png" alt="" @click="shareWb">
						</div>
					</div>
					<div class="lookAllBox" @mouseenter="enterLookAllBox" @mouseleave="hoverHot = false"
						:style="{'display': hoverHot ? 'block' : 'none', left: popXX + 'px', 'top': popYY + 'px'}">
						<div class="boxTitle">简介</div>
						<div class="boxContent">
							{{detailsData.Intro}}
						</div>
					</div>
				</div> -->
			</div>
			<div class="vInfoBox" v-if="videoInfo && videoInfo.poster && videoInfo.videoUrl">
				<img class="infoImgBox" :src="videoInfo.poster" alt="" />
				<div class="videoTitle">
					{{detailsData.Title}}
				</div>
				<div class="boxTitle">简介</div>
				<div class="boxContent">{{detailsData.Intro}}</div>
			</div>
		</div>
		<div class="videoListBox" v-if="videoInfo && videoInfo.poster && videoInfo.videoUrl">
			<div class="contentStyle">
				<div class="styleHeader">
					<div class="headerBox">
						<span class="headerTitle">为你推荐</span>
					</div>
				</div>
				<div class="videoListSBox" v-if="detailsData && detailsData.Recommand">
					<div class="itemSBox" v-for="(item,index) in detailsData.Recommand" :key="index">
						<div class="imgSBox" @mouseenter="hotMouseEnter($event,index)">
							<img :src="item.CoverUrlPortrait" alt="">
							<div class="timeNumBox">
								{{item.Duration}}
								<div class="numBox">
									{{item.Clicks}}次播放
								</div>
							</div>
						</div>
						<div class="infoSBox">
							<div class="videoTitle" @click="naviToHotDetails(item)">
								{{item.Title}}
							</div>
							<div class="videoSubTitle">
								{{item.Intro}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<BottomMenu></BottomMenu>
		<div class="loading" v-if="isLoading">
			<img src="https://img.alicdn.com/tfs/TB1qa_fdQL0gK0jSZFtXXXQCXXa-88-88.gif" alt="">
		</div>
		<PopMenu :popX="popX" :popY="popY" :isPop="isPop" @changeIsPop="changeIsPop" @naviToDetails="naviToHotDetails"
			:curReCommand="curReCommand">
		</PopMenu>
		<div class="popWx" v-if="isShowWx" @click="isShowWx=false">
			<div class="contentBox">
				<div class="title">
					分享
				</div>
				<div class="shareBox" ref="qrcodeContainer"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import VuePlyr from 'vue-plyr'
	import 'vue-plyr/dist/vue-plyr.css'
	import TopMenu from '../components/topMenu'
	import BottomMenu from '../components/bottomMenu'
	import PopMenu from '../components/popMenu'
	import QRCode from "qrcodejs2"
	// import {
	// 	videoPlayer
	// } from 'vue-video-player'
	// import 'video.js/dist/video-js.css'

	export default {
		name: 'Search',
		components: {
			TopMenu,
			VuePlyr,
			BottomMenu,
			PopMenu,
			// videoPlayer
		},
		data() {
			return {
				isShow: false,
				popX: 0,
				popY: 0,
				isPop: false,
				popXX: 0,
				popYY: 0,
				hoverHot: false,
				hoverTimer: null,
				isLoading: false,
				isShowWx: false,
				screenWidth: 0,
				columnsNum: 0,
				wxShareUrl: '',
				videoInfo: {
					poster: '',
					videoUrl: '',
				},
				curReCommand: {},
				detailsData: {},
				qrcode: "",
				playerOptions: {
					playbackRates: [1.0, 1.5, 2.0], //播放速度
					autoplay: false, // 如果true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 导致视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					// aspectRatio: '15:6', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [],
					poster: "", // 封面地址
					notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true, // 时间分割线
						durationDisplay: true, // 总时间
						remainingTimeDisplay: true, // 剩余播放时间
						progressControl: true, // 进度条 
						fullscreenToggle: true // 全屏按钮
					}
				},
				options: {
					controls: ['play-large', 'play', 'progress', 'current-time', 'duration', 'mute', 'volume', 'captions',
						'settings', 'pip', 'airplay', 'fullscreen'
					],
					i18n: {
						speed: '速度',
						normal: '正常',
						play: '播放',
						pause: '暂停',
						pip: '画中画',
						enterFullscreen: '进入全屏',
						exitFullscreen: '退出全屏',
						mute: '音量',
						unmute: '解除静音',
						settings: '设置',
					},
					tooltips: {
						controls: true,
						seek: true,
					},
					loop: {
						active: true,
					},
				},
			}
		},
		created() {
			this.screenWidth = document.body.clientWidth
			window.onresize = () => {
				return (() => {
					this.screenWidth = document.body.clientWidth
				})()
			}
		},
		watch: {
			screenWidth: {
				handler: function(val, oldVal) {
					if (val <= 1279) {
						this.columnsNum = 4
					} else if (val <= 1599) {
						this.columnsNum = 5
					} else if (val <= 1899) {
						this.columnsNum = 6
					} else {
						this.columnsNum = 7
					}
				},
			},
		},
		mounted() {
			console.log(this.$route.query)
			this.getVlogVideoDetail()
		},
		methods: {
			naviTo() {
				const player = this.$refs.player.$el
				if (document.pictureInPictureEnabled && player) {
					if (document.pictureInPictureElement === player) {
						document.exitPictureInPicture()
					} else {
						player.requestPictureInPicture()
					}
				}
			},
			showQRCode() {
				this.$refs.qrcodeContainer.innerHTML = "";
				let qrcode = new QRCode(this.$refs.qrcodeContainer, {
					text: this.wxShareUrl,
					width: 265,
					height: 265,
					colorDark: "#000000",
					colorLight: "#FFFFFF",
					correctLevel: QRCode.CorrectLevel.H,
				});
			},
			//视频详情
			getVlogVideoDetail() {
				this.isLoading = true
				this.$api.post('/VideoNew/getVlogVideoDetail', {
					VId: this.$route.query.videoId
				}).then(res => {
					if (res.code == 200) {
						this.detailsData = res.data
						this.getVideoPlayInfo(this.detailsData.VideoId)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			getVideoPlayInfo(videoId) {
				this.$api.post('/VideoNew/getVideoPlayInfo', {
					videoId: videoId
				}).then(res => {
					if (res.code == 200) {
						this.playerOptions.poster = res.data[0].PlayAuth.VideoMeta.CoverURL
						// this.playerOptions.sources[0].url = res.data[0].PlayURL
						let video = {
							src: res.data[0].PlayURL, // 路径
							type: 'video/mp4' // 类型
						};
						this.playerOptions.sources.push(video);
						this.videoInfo.poster = res.data[0].PlayAuth.VideoMeta.CoverURL
						this.videoInfo.videoUrl = res.data[0].PlayURL
					}
					this.isLoading = false
				}).catch(err => {
					console.log(err);
				})
			},
			hotMouseEnter(e, index) {
				this.curReCommand = this.detailsData.Recommand[index]
				this.isPop = true
				if (index % this.columnsNum == 0) {
					this.popX = e.target.offsetLeft
				} else if (index % this.columnsNum == this.columnsNum - 1) {
					this.popX = e.target.offsetLeft - (394 - e.target.offsetWidth)
				} else {
					this.popX = e.target.offsetLeft - (394 - e.target.offsetWidth) / 2
				}
				this.popY = e.target.offsetTop - (440 - e.target.offsetHeight - 50) / 2
			},
			// hotMouseLookAllEnter(event) {
			// 	console.log(event, event.target.offsetLeft, event.target.offsetTop)
			// 	this.popXX = event.target.clientWidth
			// 	this.popYY = event.target.offsetTop + 40
			// 	clearTimeout(this.hoverTimer)
			// 	this.hoverHot = true
			// },
			// hotMouseLookAllLeave(event) {
			// 	let that = this
			// 	this.hoverTimer = setTimeout(() => {
			// 		that.hoverHot = false
			// 	}, 200)
			// },
			shareWx() {
				let getId = this.$route.query.videoId;
				let url = `https://www.financeun.com/videoShareH5?VId=${getId}`;
				this.wxShareUrl = url
				this.isShowWx = true
				this.$nextTick(() => {
					this.showQRCode()
				})
				// this.wechatErweima = 'http://api.k780.com:88/?app=qr.get&data=' + url + '&level=L&size=6';
			},
			shareQq() {
				let getId, getPlat;
				getId = this.$route.query.videoId;
				getPlat = 'pc';
				let url =
					`https://www.financeun.com/videoShareH5?VId=${getId}&platForm=${getPlat}&from=singlemessage&isappinstalled=0`;
				window.open(
					`http://connect.qq.com/widget/shareqq/index.html?url=${url}&sharesource=qzone&title=${this.detailsData.Title}&pics=${this.shareLogo}&summary=${this.detailsData.NickName}&desc=${this.detailsData.Intro}`
				);
			},
			shareWb() {
				let getId, getPlat, shareLogo;
				getId = this.$route.query.videoId;
				getPlat = 'pc';
				shareLogo = 'https://cfni.cn/shareLogo.png'
				let url =
					`https://www.financeun.com/videoShareH5?VId=${getId}&platForm=${getPlat}&from=singlemessage&isappinstalled=0`;

				window.open(
					`http://service.weibo.com/share/share.php?url=${url}&sharesource=weibo&title=${this.detailsData.Title}&pic=${shareLogo}&appkey=${this.detailsData.Intro}`
				);
			},
			enterLookAllBox() {
				clearTimeout(this.hoverTimer)
				this.hoverHot = true
			},
			changeIsPop(isShow) {
				this.isPop = isShow
			},
			naviToHotDetails(vid) {
				let routeData = this.$router.resolve({
					path: '/Details',
					query: {
						videoId: vid
					}
				});
				window.open(routeData.href, '_blank');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.loading {
		position: absolute;
		left: calc(50% - 22px);
		top: 70px;

		img {
			width: 44px;
			height: 44px;
		}
	}

	.popWx {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100vw;
		height: 100vh;
		background: rgba(255, 255, 255, 0.5);
		z-index: 100;

		display: flex;
		align-items: center;
		justify-content: center;

		.contentBox {
			width: 435px;
			height: 435px;
			background: #FFFFFF;
			border-radius: 8px;
			padding: 40px;
			box-sizing: border-box;

			display: flex;
			flex-direction: column;
			align-items: center;

			.shareBox {
				margin-top: 40px;
				width: 265px;
				height: 265px;
			}
		}
	}

	.videoInfoBox {
		display: flex;
		min-height: 200px;
	}

	.vInfoBox {
		width: 280px;
		margin-top: 70px;
		margin-left: 20px;
		background: #25252B;
		border-radius: 8px;
		min-height: 490px;
		height: calc((100vw - 384px) / 1.78 + 88px);
		overflow: hidden;
		border-bottom: 8px solid #25252B;
		box-sizing: border-box;

		.infoImgBox {
			display: block;
			width: 280px;
			height: 174px;
		}

		.videoTitle {
			margin: 32px 8px 0px;
			font-size: 24px;
			font-weight: 500;
			color: #FBFBFD;
		}

		.boxTitle {
			margin: 32px 8px 0px;
			font-size: 20px;
			font-weight: 500;
			color: #767678;
		}

		.boxContent {
			margin: 12px 8px 8px;
			font-size: 16px;
			font-weight: 400;
			color: #767678;
		}
	}

	.videoBox {
		margin-top: 70px;
		margin-left: 42px;
		background: #25252B;
		min-width: 716px;
		width: calc(100vw - 384px);
		border-radius: 8px;

		.videoPlayer {
			width: 100%;
			min-height: 402px;
			height: calc((100vw - 384px) / 1.78);
		}

		.otherShareBox {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 28px 30px 20px 16px;
			box-sizing: border-box;

			.titleTime {
				display: flex;

				.playNum {
					text-align: right;
					font-size: 16px;
					font-weight: 400;
					color: #767678;
				}

				.timeBox {
					display: flex;
					align-items: center;
					font-size: 16px;
					font-weight: 400;
					color: #767678;
					margin-left: 4px;

					span {
						margin-left: 20px;
					}
				}
			}

			.shareBox {
				display: flex;
				align-items: center;
				font-size: 16px;
				font-weight: 400;
				color: #767678;

				.shareType {
					display: flex;
					align-items: center;


					.shareImg {
						margin-left: 24px;
						width: 40px;
						height: 40px;
						cursor: pointer;
					}
				}
			}
		}

	}

	.videoListBox {
		margin-top: 70px;
		margin-left: 42px;
		margin-right: 30px;
	}

	.contentStyle {
		color: rgba(255, 255, 255, 0.87);

		.styleHeader {
			display: flex;
			align-items: baseline;
			justify-content: space-between;

			.headerBox {
				margin: 0px 0px 10px;
				height: 50px;
				line-height: 50px;

				.headerTitle {
					font-size: 24px;
					font-weight: 500;
					text-align: left;
					cursor: auto;
				}
			}
		}

		.videoListSBox {
			display: flex;
			flex-wrap: wrap;

			.itemSBox {
				padding-right: 12px;
				box-sizing: border-box;
				margin-bottom: 60px;

				.imgSBox {
					border-radius: 10px 10px 0px 0px;
					background: #25252b;
					position: relative;
					overflow: hidden;
					cursor: pointer;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}

					.timeNumBox {
						display: flex;
						align-items: center;
						justify-content: space-between;
						width: 100%;
						height: 26px;
						line-height: 26px;
						background: rgba(4, 4, 4, .29);
						position: absolute;
						bottom: 0px;
						left: 0px;
						text-align: right;
						padding: 0px 12px;
						box-sizing: border-box;
						font-size: 12px;
						font-weight: 400;
						color: #FAF7F7;
					}
				}

				.infoSBox {
					padding-top: 10px;

					.videoTitle {
						height: 22px;
						width: 100%;
						line-height: 22px;
						font-size: 16px;
						font-weight: 500;
						overflow: hidden;
						text-overflow: ellipsis;
						word-break: break-all;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						word-break: break-word;
						cursor: pointer;
					}

					.videoTitle:hover {
						color: #4ae3fa;
					}

					.videoSubTitle {
						color: rgba(255, 255, 255, 0.5);
						margin-top: 3px;
						height: 14px;
						line-height: 14px;
						font-size: 14px;
						font-weight: 400;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}
	}

	.lookAllBox {
		width: 540px;
		position: absolute;
		border-radius: 15px;
		padding: 18px 8px 18px 24px;
		background: rgba(37, 37, 43, .7);

		.boxTitle {
			font-size: 20px;
			font-weight: 500;
			color: #FBFBFD;
		}

		.boxContent {
			margin-top: 18px;
			font-size: 16px;
			font-weight: 400;
			color: #767678;
		}
	}

	@media (max-width: 1099px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((1100px - 72px) / 4);

			.imgBox {
				height: calc((1100px - 72px) / 4 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((1100px - 72px) / 4 * 2);

			.imgTBox {
				height: calc((1100px - 72px) / 4 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((1100px - 72px) / 4);

			.imgSBox {
				height: calc((1100px - 72px) / 4 * 1.333);
			}
		}
	}

	@media (min-width: 1100px) and (max-width:1279px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 72px) / 4);

			.imgBox {
				height: calc((100vw - 72px) / 4 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 72px) / 4 * 2);

			.imgTBox {
				height: calc((100vw - 72px) / 4 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 72px) / 4);

			.imgSBox {
				height: calc((100vw - 72px) / 4 * 1.333);
			}
		}
	}

	@media (min-width: 1280px) and (max-width:1599px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 72px) / 5);

			.imgBox {
				height: calc((100vw - 72px) / 5 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 72px) / 5 * 2);

			.imgTBox {
				height: calc((100vw - 72px) / 5 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 72px) / 5);

			.imgSBox {
				height: calc((100vw - 72px) / 5 * 1.333);
			}
		}
	}

	@media (min-width: 1600px) and (max-width:1899px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 72px) / 6);

			.imgBox {
				height: calc((100vw - 72px) / 6 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 72px) / 6 * 2);

			.imgTBox {
				height: calc((100vw - 72px) / 6 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 72px) / 6);

			.imgSBox {
				height: calc((100vw - 72px) / 6 * 1.333);
			}
		}
	}

	@media (min-width: 1900px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 72px) / 7);

			.imgBox {
				height: calc((100vw - 72px) / 7 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 72px) / 7 * 2);

			.imgTBox {
				height: calc((100vw - 72px) / 7 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 72px) / 7);

			.imgSBox {
				height: calc((100vw - 72px) / 7 * 1.333);
			}
		}
	}
</style>